import { ReactElement } from 'react';
import { Typography } from 'antd';
import type { Honbu } from '../types';
import { HONBU_LABEL } from '../types';

const { Title: AntTitle, Paragraph } = Typography;

interface Props {
  honbu: Honbu;
}

const Title = ({ honbu }: Props): ReactElement => {
  return (
    <>
      <AntTitle level={1}>{HONBU_LABEL[honbu]}用設定</AntTitle>
      <Paragraph type='secondary'>
        拠点ごとに自動架電の時間帯と転送先を、拠点配下の広告コードごとに自動架電対象の仕事Noを設定します。
      </Paragraph>
    </>
  );
};

export default Title;
